import React from 'react';
import { useTranslation } from 'react-i18next';
import { Steps } from 'components/ds';

/**
 * 모임 만들기 진행 표시.
 *
 * 예전에는 단계마다 다른 그라디언트 색(인디고/에메랄드/앰버)을 썼는데,
 * 색만으로 상태를 나누면 화면마다 톤이 갈라지고 색각 차이에도 약합니다.
 * 지금은 ds 의 Steps 로 선 굵기와 글자 굵기로 구분합니다.
 */

interface MeetingProgressProps {
    /** 지금 단계 (1부터) */
    currentStep: number;
    isTravel?: boolean;
}

export const MeetingProgress: React.FC<MeetingProgressProps> = ({ currentStep, isTravel }) => {
    const { t } = useTranslation();

    const labels = isTravel
        ? [t('createFlow.stepType'), t('createFlow.stepInfo'), t('meetingForm.travelDest'), t('race.stepGather')]
        : [t('createFlow.stepType'), t('createFlow.stepInfo'), t('race.stepSchedulePlace')];

    return <Steps labels={labels} current={currentStep} />;
};

export default MeetingProgress;
